import { Select, SelectContent, SelectItem, SelectTrigger } from "@workspace/web-ui/components/select";
import { cn } from "@workspace/web-ui/lib/utils";
import { Trash } from "lucide-react";
import { useState } from "react";
import { TaskForm } from "./task-form";
import { useMedicationsStore } from "./store/use-medication-store";

interface TaskCardProps {
    id: string // THIS IS THE ENCOUNTER ID
    open: boolean
    onOpenChange: (open: boolean) => void
    className?: string
}

type SelectedTask = "appointment_followup" | "medication_payment" | string

export function Tasks({ id, open, onOpenChange, className}: TaskCardProps) {
    const [selectedValue, setSelectedValue] = useState<SelectedTask>("")
    const { medications } = useMedicationsStore();


    const handleSelectedValue = (value: SelectedTask) => {
        setSelectedValue(value)
        if (value === "medication_payment") {
            // Clear medications array
            if (medications.length > 0 || medications.length === 0) {
                // Directly set medications to empty array
                useMedicationsStore.setState({ medications: [{ medication_name: '', dosage: '', cost: '', duration: '', instructions: '' }] });
            }
        }
    }

    if (!open) return null;

    const selectedText =
        selectedValue === "appointment_followup"
            ? "Book appointment"
            : selectedValue === "medication_payment"
            ? "Medication Payment"
            : "Select";

    return (
        <>
            <div className="w-full flex flex-col gap-4 rounded-lg border mb-10 mt-4">
                <div className={cn("bg-white p-4 rounded-lg flex flex-col gap-2", className)}>
                <div className="flex gap-2 justify-between items-center mt-3">
                    <h2 className="text-[16px] font-medium text-[#2D2F35]">New Task</h2>
                    <button
                        onClick={() => onOpenChange(false)}
                        className="hover:bg-gray-100 rounded-full p-1 transition-colors"
                    >
                        <Trash className="w-4 h-4 text-[#363840] -mt-3" />
                    </button>
                </div>
                <div className="mt-2">
                    <p className="text-[14px]">Type</p>
                </div>
                <Select
                    onValueChange={handleSelectedValue}
                    value={selectedValue}
                >
                    <SelectTrigger
                        className={cn(
                            "w-full button-select !rounded-lg",
                            "!ring-0 !ring-offset-0 h-fit",
                            "focus:!ring-0 focus:!ring-offset-0",
                            "!outline-none focus:!outline-none",
                        )}
                    >
                        {selectedText}
                    </SelectTrigger>
                    <SelectContent className="flex flex-col gap-2">
                        <SelectItem
                            value="appointment_followup"
                            className="focus:!ring-0 focus:!ring-offset-0 cursor-pointer"
                        >
                            Book appointment
                        </SelectItem>
                        <SelectItem
                            value="medication_payment"
                            className="focus:!ring-0 focus:!ring-offset-0 cursor-pointer"
                        >
                            Medication Payment
                        </SelectItem>
                    </SelectContent>
                </Select>
                <div className={cn("flex mt-4 w-full flex-col gap-4 ", className)}>
                    <TaskForm type={selectedValue} id={id} onOpenChange={onOpenChange} className={className || ""} />
                </div>
                </div>
            </div>

        </>
    )
}


